import { render, staticRenderFns } from "./InitialRecoveryForm.vue?vue&type=template&id=12462d45&scoped=true&"
import script from "./InitialRecoveryForm.vue?vue&type=script&lang=js&"
export * from "./InitialRecoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./InitialRecoveryForm.vue?vue&type=style&index=0&id=12462d45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12462d45",
  null
  
)

export default component.exports